var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M5.19 10.955c.206-.285.504-.49.844-.58c.917-.23 2.293-1.152 2.751-1.61c.459-.463 1.376-2.306 1.608-2.77l.025-.05c.077-.172.249-.54.609-.802a6.9 6.9 0 0 0-5.837 5.812m-.047 1.667a6.9 6.9 0 0 0 6.03 6.235c-.232-.201-.369-.484-.485-.732l-.068-.142l-.103-.227c-.27-.626-.947-2.177-1.732-2.769c-.917-.69-1.834-1.384-2.524-1.615c-.428-.142-.857-.373-1.118-.75m7.774 6.223a6.9 6.9 0 0 0 5.94-6.3a1.8 1.8 0 0 1-.896.6c-.686.227-2.293 1.38-2.751 1.842a13 13 0 0 0-1.839 3a2 2 0 0 1-.454.858m5.893-7.835a6.9 6.9 0 0 0-5.846-5.867c.27.21.48.486.613.801l.026.052l.167.377c.265.621.703 1.654 1.44 2.391c.728.738 1.757 1.18 2.378 1.445c.155.068.283.12.373.171c.266.129.609.343.849.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.493 8.477a.471.471 0 0 0-.896-.008a4.66 4.66 0 0 1-3.12 3.043a.472.472 0 0 0-.009.891a4.66 4.66 0 0 1 3.043 3.12a.472.472 0 0 0 .892.009a4.65 4.65 0 0 1 3.12-3.043a.471.471 0 0 0 .008-.892a4.65 4.65 0 0 1-3.043-3.12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStg);
export default __webpack_public_path__ + "static/media/stg.f78d3d2dc67c4dae87b4cf4e0f994805.svg";
export { ForwardRef as ReactComponent };